var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ChartInteraction'),_c('b-card',{attrs:{"body-class":"p-0","header-class":"border-0"}},[_c('transaction-search-results',{attrs:{"query":{
        statuses: ['APPROVED', 'DECLINED'],
        currentPage: 1,
        modules: [
          'TEXTTOPAY',
          'PAYMENTPLAN',
          'MEMBERSHIP',
          'TERMINAL',
          'VIRTUALTERMINAL',
          'PAYMENTPAGE' ],
        sortOption: 'Date:descending',
      }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }